import track from "../track";
import sdkProvider from "../sdkProvider";
import mapGlobalsToAppMeasurementInstance from "../mapGlobalsToAppMeasurementInstance";
import mapToAppMeasurementInstance from "./mapToAppMeasurementInstance";

export default ({ state }) => {
  const mappedGlobals = mapGlobalsToAppMeasurementInstance(state);
  const { trackPage: sdkMethod } = sdkProvider();
  track({
    sdkMethod,
    instancePayload: {
      ...mapToAppMeasurementInstance(state),
      ...mappedGlobals
    }
  });
};
